import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Transaction from "../../components/users/component/affiliater/transaction.jsx";
import {
  formatDate,
  anonymizeText,
} from "../../components/product/component/sharedFunction.js";

import { ConfirmEraseUserAccount } from "../../components/modal/confirm/confirmEraseUserAccount.js";
// import { ConfirmEraseUserDeleteWithAccount } from "../../components/modal/confirm/confirmEraseUserDeleteWithAccount.js";

function AdminAffiliater() {
  const { id } = useParams();
  const [data, setData] = useState("");
  const [transactions, setTransactions] = useState(0);
  const { i18n } = useTranslation();
  const [link, setLink] = useState(0);
  const [affiliates, setAffiliates] = useState(0);
  const [comissions, setComissions] = useState(0);
  const [itemsPerPage] = useState(5);
  const [posts, setPosts] = useState("");
  const [endOffset, setEndOffset] = useState("");
  const [currentItems, setCurrentItems] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  let navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      window.location.replace(process.env.REACT_APP_URL + `/users/sign_in`);
    }
    const config = {
      headers: { Authorization: `${token}` },
    };

    axios
      .get(process.env.REACT_APP_URL_API + `/specific_client/${id}`, config)
      .then((response) => {
        if (response["data"]) {
          const data = response.data;
          setLink(`${process.env.REACT_APP_URL}/aff/${data.user.uuid}`);
          setData(data);
        }
      });

    axios
      .get(
        process.env.REACT_APP_URL_API + `/affiliate_information?id=${id}`,
        config
      )
      .then((response) => {
        // setNbAffiliate(response['data'].nbAffiliate);
        setAffiliates(response["data"].affiliates);
        setComissions(response["data"].comissions);
        setPosts(response["data"].affiliates);
        setEndOffset(itemOffset + itemsPerPage);
        setCurrentItems(
          response["data"].affiliates.slice(itemOffset, endOffset)
        );
        setPageCount(
          Math.ceil(response["data"].affiliates.length / itemsPerPage)
        );
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(process.env.REACT_APP_URL_API + `/get_transactions?id=${id}`, config)
      .then((response) => {
        setTransactions(response["data"]["transactions"]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [endOffset, id, itemOffset, itemsPerPage]);

  return (
    <div>
      <div className="container flex flex-col gap-x-4 ">
        <h1 className="text-secondary pb-2.5 text-left">Administration</h1>
        <div className="flex flex-row justify-between pb-8">
          <button
            onClick={() =>
              (window.location =
                process.env.REACT_APP_URL + "/users/admin?affiliation")
            }
            className="btn bg-white border border-gray-custom-input flex flex-row gap-x-3.5"
          >
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.5 12.5L7.5 9.5L10.5 6.5"
                stroke="#486497"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="text-secondary">retour</span>
          </button>
          <div className="flex flex-row gap-x-2.5">
            {data.user &&
              (data.user.role === "admin" ||
                data.user.role === "affiliater") && (
                <Link
                  to={`/users/admin/${data.user.id}`}
                  className="flex flex-row gap-x-1 bg-white text-white border border-gray-custom-input btn p-3.5 rounded-custom-input"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 4.875C5.43268 4.875 3.1284 8.67461 3.08672 8.7438C3.03062 8.81667 3.00006 8.90696 3 9C3.00007 9.07982 3.0226 9.1579 3.06484 9.22478C3.06536 9.22559 3.06588 9.22639 3.06641 9.2272C3.07328 9.24183 5.00753 13.125 9 13.125C12.9755 13.125 14.9069 9.27998 14.9305 9.23284C14.9321 9.23017 14.9336 9.22748 14.9352 9.22478C14.9774 9.1579 14.9999 9.07982 15 9C15 8.90733 14.9697 8.81737 14.9141 8.7446L14.9133 8.7438C14.8716 8.67461 12.5673 4.875 9 4.875ZM9 6.1125C10.5464 6.1125 11.8 7.40528 11.8 9C11.8 10.5947 10.5464 11.8875 9 11.8875C7.4536 11.8875 6.2 10.5947 6.2 9C6.2 7.40528 7.4536 6.1125 9 6.1125ZM9 7.7625C8.68174 7.7625 8.37651 7.89288 8.15147 8.12496C7.92643 8.35703 7.8 8.67179 7.8 9C7.8 9.32821 7.92643 9.64297 8.15147 9.87504C8.37651 10.1071 8.68174 10.2375 9 10.2375C9.31826 10.2375 9.62348 10.1071 9.84853 9.87504C10.0736 9.64297 10.2 9.32821 10.2 9C10.2 8.67179 10.0736 8.35703 9.84853 8.12496C9.62348 7.89288 9.31826 7.7625 9 7.7625Z"
                      fill="#486497"
                    />
                  </svg>
                </Link>
              )}

            <ConfirmEraseUserAccount
              from="admin"
              accept={() => console.log("TODO")}
              acceptNotification={
                data.plan && data.plan.status === -2
                  ? i18n.t("account.accept_notification_reactivate")
                  : i18n.t("account.accept_notification_delete")
              }
              rejectNotification={
                data.plan && data.plan.status === -2
                  ? i18n.t("account.reject_notification_reactivate")
                  : i18n.t("account.reject_notification_delete")
              }
              label={
                data.plan && data.plan.status === -2
                  ? i18n.t("account.reactivate")
                  : i18n.t("account.delete")
              }
              rejectLabel={i18n.t("account.no_thanks")}
              message={
                data.plan && data.plan.status === -2
                  ? i18n.t("account.message_reactivate")
                  : i18n.t("account.message_delete")
              }
              header={
                data.plan && data.plan.status === -2
                  ? i18n.t("account.header_reactivate")
                  : i18n.t("account.header_delete")
              }
            ></ConfirmEraseUserAccount>
          </div>
        </div>
        <div className="flex flex-col gap-x-4 gap-y-8">
          <div className="flex flex-col gap-y-2">
            <h3 className="text-primary font-semibold text-left">
              Lien de l'affiliateur
            </h3>
            <div className="flex flex-row gap-x-5">
              <div className="flex gap-y-1 relative w-full">
                <CopyToClipboard
                  text={link}
                  style={{
                    marginLeft: "auto",
                    marginTop: "1rem",
                    marginRight: "1rem",
                    right: "0",
                    top: "0",
                    cursor: "pointer",
                    position: "absolute",
                  }}
                >
                  <svg
                    width="15"
                    height="18"
                    viewBox="0 0 15 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.7991 5.30778L9.75337 0.202985C9.62527 0.0731077 9.45117 0 9.26969 0H7.01606C6.35062 0 5.71228 0.267508 5.24174 0.743538C4.7712 1.21957 4.50677 1.86535 4.50677 2.53855V3.69249H3.36613C2.70069 3.69249 2.06235 3.96 1.59181 4.43603C1.12154 4.91178 0.857117 5.55757 0.857117 6.23077V15.4614C0.857117 16.1346 1.12154 16.7804 1.59208 17.2565C2.06263 17.7325 2.70097 18 3.36641 18H9.75337C10.4188 18 11.0572 17.7325 11.5277 17.2565C11.9982 16.7804 12.2627 16.1346 12.2627 15.4614V14.3075H12.4907C13.1561 14.3075 13.7945 14.04 14.265 13.564C14.7356 13.0879 15 12.4422 15 11.769V5.76914C14.9929 5.59523 14.9211 5.43046 14.7993 5.30751L14.7991 5.30778ZM9.98139 2.36326L12.664 5.07711H9.98139V2.36298V2.36326ZM10.8937 15.4617C10.8937 15.7677 10.7736 16.0613 10.5598 16.2775C10.346 16.4938 10.0558 16.6154 9.75337 16.6154H3.36641C3.06394 16.6154 2.77378 16.4938 2.56 16.2775C2.34621 16.0613 2.22605 15.7677 2.22605 15.4617V6.23077C2.22605 5.92477 2.34621 5.63123 2.56 5.41495C2.77378 5.19868 3.06394 5.07711 3.36641 5.07711H4.50705V11.7695C4.50705 12.4427 4.77147 13.0885 5.24201 13.5645C5.71256 14.0406 6.3509 14.3081 7.01634 14.3081H10.8943V15.462L10.8937 15.4617ZM12.4904 12.9232H7.01606C6.71359 12.9232 6.42344 12.8016 6.20965 12.5853C5.99587 12.369 5.8757 12.0755 5.8757 11.7695V2.53855C5.8757 2.23255 5.99587 1.93902 6.20965 1.72274C6.42344 1.50646 6.71359 1.38489 7.01606 1.38489H8.61274V5.76914C8.6152 5.95191 8.68801 6.12665 8.81585 6.25597C8.94368 6.38529 9.1164 6.45895 9.29706 6.46145H13.631V11.7692C13.631 12.0752 13.5109 12.3688 13.2971 12.585C13.0833 12.8013 12.7932 12.9229 12.4907 12.9229L12.4904 12.9232Z"
                      fill={"#486497"}
                    />
                  </svg>
                </CopyToClipboard>
                <div
                  className={`text-left bg-white border rounded-custom-input padding-custom-input font-normal text-primary w-full border-gray-custom-input`}
                  name="link"
                  id="link"
                >
                  {link}
                </div>
              </div>
              {/* <a
                href="https://www.dropbox.com/home/Screebot/Espace%20Affiliation"
                target="_blank"
                rel="noreferrer"
                className={`padding-custom-button flex flex-row gap-x-3 bg-secondary text-white border border-gray-custom-input rounded-custom-input btn whitespace-nowrap`}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_3515_7126)">
                    <path
                      d="M17.9663 4.81749C17.7815 3.75823 16.8725 2.93383 15.7046 2.76617C15.5693 2.7468 15.4336 2.73974 15.2435 2.73724C15.1119 2.33176 14.9039 1.97548 14.5689 1.6716C14.0648 1.21464 13.4304 1.01805 12.6769 0.926016C11.9412 0.836264 11.0034 0.837403 9.83725 0.837403H8.16275C6.99661 0.837403 6.05877 0.836264 5.32312 0.925789C4.56963 1.01759 3.93495 1.21418 3.43112 1.67137C3.09607 1.97525 2.88811 2.33153 2.7565 2.73701C2.56612 2.73951 2.43074 2.74658 2.29537 2.76594C1.12746 2.93383 0.218511 3.75823 0.0334045 4.81749C0 5.00929 0 5.2011 0 5.58334V12.4173C0 12.7995 0 12.9913 0.0334045 13.1829C0.218259 14.2422 1.12721 15.0666 2.29511 15.2342C2.43049 15.2536 2.56612 15.2606 2.75625 15.2632C2.88786 15.6686 3.09582 16.0249 3.43087 16.329C3.9347 16.786 4.56938 16.9826 5.32287 17.0746C6.05827 17.1644 6.99611 17.163 8.1625 17.163H9.837C11.0031 17.163 11.941 17.1641 12.6766 17.0746C13.4301 16.9828 14.0645 16.7862 14.5686 16.329C14.9037 16.0251 15.1116 15.6686 15.2432 15.2632C15.4336 15.2606 15.5693 15.2536 15.7044 15.2342C16.8723 15.0666 17.7812 14.2422 17.9661 13.1829C17.9995 12.9911 17.9995 12.7993 17.9995 12.417V5.58311C17.9995 5.2011 17.9995 5.00929 17.9661 4.81749H17.9663ZM1.27389 13.0045C1.25581 12.9013 1.25581 12.7294 1.25581 12.417V5.58311C1.25581 5.2708 1.25581 5.09882 1.27389 4.99562C1.3736 4.42522 1.86287 3.98147 2.49177 3.89103C2.51061 3.8883 2.53196 3.88602 2.55532 3.8842C2.51111 4.46235 2.51162 5.15144 2.51162 5.96285V12.0375C2.51162 12.849 2.51111 13.5378 2.55532 14.1162C2.53196 14.1144 2.51061 14.1121 2.49177 14.1094C1.86287 14.0191 1.3736 13.5752 1.27389 13.0048V13.0045ZM12.5096 15.9456C11.8772 16.0226 11.0391 16.024 9.83725 16.024H8.16275C6.96094 16.024 6.12282 16.0229 5.49039 15.9456C4.87605 15.8707 4.5508 15.7338 4.31898 15.5235C4.08715 15.3133 3.9362 15.0183 3.85357 14.4611C3.76843 13.8875 3.76717 13.1273 3.76717 12.0373V11.3699L4.66935 10.5302C4.81653 10.3933 4.99083 10.3238 5.17318 10.3291C5.35828 10.3347 5.53811 10.4204 5.67952 10.5707L8.32576 13.385C8.97225 14.0725 10.0294 14.1652 10.7846 13.6007L10.9687 13.4631C11.4198 13.126 12.0013 13.1658 12.4157 13.5626L12.4395 13.5854L14.0698 14.8347C13.9817 15.1611 13.8533 15.3659 13.6803 15.5228C13.4484 15.7331 13.1232 15.87 12.5089 15.945L12.5096 15.9456ZM16.7442 12.417C16.7442 12.7294 16.7442 12.9013 16.7261 13.0045C16.6266 13.5749 16.1371 14.0187 15.5082 14.1091C15.4226 14.1214 15.2942 14.1244 15.0898 14.1253L13.302 12.7553C12.4333 11.9469 11.1219 11.8735 10.1705 12.5845L9.98644 12.7221C9.76039 12.8909 9.48386 12.8613 9.28168 12.6462L6.63544 9.832C6.26221 9.43495 5.75788 9.20738 5.21537 9.19098C4.67839 9.1748 4.16501 9.3682 3.77044 9.73541L3.76742 9.73815V5.96285C3.76742 4.87284 3.76868 4.11268 3.85382 3.53908C3.93646 2.98189 4.0874 2.68689 4.31923 2.47664C4.55105 2.26638 4.8763 2.12947 5.49064 2.05453C6.12307 1.9773 6.9612 1.97616 8.163 1.97616H9.8375C11.0393 1.97616 11.8774 1.9773 12.5099 2.05453C13.1242 2.12947 13.4495 2.26638 13.6813 2.47664C13.9131 2.68689 14.064 2.98189 14.1467 3.53908C14.2316 4.11268 14.2331 4.87284 14.2331 5.96285V11.2781C14.2331 11.5926 14.5141 11.8476 14.861 11.8476C15.2078 11.8476 15.4889 11.5926 15.4889 11.2781V5.96285C15.4889 5.15144 15.4894 4.46258 15.4452 3.8842C15.4685 3.88602 15.4899 3.8883 15.5087 3.89103C16.1376 3.98147 16.6269 4.42522 16.7266 4.99562C16.7447 5.09882 16.7447 5.2708 16.7447 5.58311V12.417H16.7442Z"
                      fill="white"
                    />
                    <path
                      d="M11.0931 3.11523C10.0543 3.11523 9.20935 3.88177 9.20935 4.82372C9.20935 5.76566 10.0543 6.5322 11.0931 6.5322C12.1319 6.5322 12.9768 5.76566 12.9768 4.82372C12.9768 3.88177 12.1319 3.11523 11.0931 3.11523ZM11.0931 5.39321C10.7467 5.39321 10.4652 5.13785 10.4652 4.82372C10.4652 4.50958 10.7467 4.25422 11.0931 4.25422C11.4394 4.25422 11.721 4.50958 11.721 4.82372C11.721 5.13785 11.4394 5.39321 11.0931 5.39321Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3515_7126">
                      <rect
                        width="18"
                        height="16.3256"
                        fill="white"
                        transform="translate(0 0.837402)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                éléments graphiques
              </a> */}
            </div>
          </div>
          <div className="flex flex-row gap-x-2">
            <div className="screebot-card flex-col w-full gap-x-1">
              <div className="account-subtitle text-primary text-lg font-medium text-left pb-4">
                Commissions d’affiliation
              </div>
              <div className="flex flex-col gap-y-1">
                <div className="small-card-screebot justify-between">
                  <div className="flex flex-col gap-y-1">
                    <span className="text-primary font-medium">
                      Année en cours
                    </span>
                    <span className="text-gray">
                      {new Date().getFullYear()}
                    </span>
                  </div>
                  <div className="my-auto text-md">
                    <span className="text-green label font-extrabold text-md">
                      {comissions.comission_total_current_month +
                        comissions.current_year_comission_year}
                    </span>
                    <span className="text-md label text-primary text-sm font-medium">
                      {" "}
                      € HT
                    </span>
                  </div>
                </div>
                <div className="small-card-screebot justify-between">
                  <div className="flex flex-col gap-y-1">
                    <span className="text-primary font-medium">
                      Trimestre en cours
                    </span>
                    <span className="text-gray">
                      {Math.ceil((new Date().getMonth() + 1) / 3)}ème trimestre{" "}
                      {new Date().getFullYear()}
                    </span>
                  </div>
                  <div className="my-auto text-md">
                    <span className="text-green label font-extrabold text-md">
                      {comissions.comission_total_current_month +
                        comissions.current_year_comission_quarter}
                    </span>
                    <span className="text-md label text-primary text-sm font-medium">
                      {" "}
                      € HT
                    </span>
                  </div>
                </div>
                <div className="small-card-screebot justify-between">
                  <div className="flex flex-col gap-y-1">
                    <span className="text-primary font-medium">
                      Commmisions N+1
                    </span>
                    <span className="text-gray">
                      {new Date().getFullYear() - 1} vs{" "}
                      {new Date().getFullYear()}
                    </span>
                  </div>
                  <div className="my-auto text-md">
                    <span className="text-green label font-extrabold text-md">
                      {comissions.previous_year_comission_year !== 0 ? (
                        <>
                          {comissions.current_year_comission_year >
                          comissions.previous_year_comission_year
                            ? "+"
                            : "-"}
                          {(
                            ((comissions.current_year_comission_year -
                              comissions.previous_year_comission_year) /
                              comissions.previous_year_comission_year) *
                            100
                          ).toFixed(2)}
                        </>
                      ) : (
                        "N/C"
                      )}
                    </span>
                    <span className="text-md label text-primary text-sm font-medium">
                      {comissions.previous_year_comission_year !== 0
                        ? " %"
                        : ""}
                    </span>
                  </div>
                </div>
                <div className="small-card-screebot justify-between">
                  <div className="flex flex-col gap-y-1">
                    <span className="text-primary font-medium">
                      Depuis l'inscription
                    </span>
                    <span className="text-gray">
                      {data && (
                        <span>
                          depuis le {formatDate(data.user.created_at)}
                        </span>
                      )}
                    </span>
                  </div>
                  <div className="my-auto text-md">
                    <span className="text-green label font-extrabold text-md">
                      {comissions.comission_total_current_month +
                        comissions.comission_total}
                    </span>
                    <span className="text-md label text-primary text-sm font-medium">
                      {" "}
                      € HT
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="screebot-card flex flex-col w-full gap-x-1">
              <div className="account-subtitle text-primary text-lg font-medium pb-4 text-left">
                Dernières affiliations
              </div>
              <div className="">
                {!affiliates?.length > 0 && (
                  <div className="text-error font-medium text-lg">
                    Aucun affilié
                  </div>
                )}
                {affiliates?.length > 0 &&
                  affiliates.slice(0, 4).map((affiliate, index) => (
                    <div
                      key={index}
                      className={`small-card-screebot justify-between`}
                    >
                      <div className="flex flex-col">
                        <span className="text-sm text-primary text-left">
                          {affiliate.first_name === null
                            ? "N/C"
                            : affiliate.first_name}{" "}
                          {affiliate.last_name === null
                            ? "N/C"
                            : anonymizeText(affiliate.last_name, "full")}
                        </span>
                        <span className="text-xs text-secondary">
                          {anonymizeText(
                            affiliate.email.substring(0, 30),
                            "start_to_end"
                          )}
                        </span>
                      </div>
                      <div className="text-sm text-center my-auto">
                        {affiliate.plan === null && (
                          <span className="text-xs text-error">N/C</span>
                        )}
                        {affiliate.plan !== null && (
                          <span className="text-green badge-plan-affiliate">
                            {affiliate.plan.name}
                          </span>
                        )}
                      </div>
                      <span className="text-sm text-right text-secondary my-auto">
                        {formatDate(affiliate.created_at)}
                      </span>
                    </div>
                  ))}
              </div>
            </div>
            <div className="screebot-card flex flex-col w-full gap-x-1">
              <div className="account-subtitle text-primary text-lg font-medium pb-4 text-left">
                État de paiement des commissions
              </div>
              {!transactions?.length > 0 && (
                <div className="text-error font-medium text-lg">
                  Aucune transaction
                </div>
              )}
              <div>
                {transactions &&
                  transactions.slice(0, 4).map((transaction, index) => (
                    <div key={index}>
                      <Transaction
                        from="small_card"
                        view="admin"
                        transaction={transaction}
                      ></Transaction>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          {data &&
            (data.user.role === "affiliater" || data.user.role === "admin") && (
              <div className="screebot-card flex flex-col w-full">
                {!transactions?.length > 0 && (
                  <div className="text-error font-medium text-lg">
                    Aucune transaction
                  </div>
                )}
                {transactions &&
                  transactions.map((transaction, index) => (
                    <div key={index}>
                      <Transaction
                        from="big_card"
                        view="admin"
                        transaction={transaction}
                      ></Transaction>
                      {index !== transactions.length - 1 && (
                        <hr className="transaction-divider" />
                      )}
                    </div>
                  ))}
              </div>
            )}
        </div>
      </div>
    </div>
  );
}

export default AdminAffiliater;
